import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/fp/isEmpty';
import { IngredientsList, Section } from 'components/shared';
import styles from './IngredientsSummary.module.scss';
import { selectCurrentProduct } from 'store/currentProduct';
import { Ingredient, Product } from 'types/magento.types';
import { IIngredientsSummaryProps } from './IngredientsSummary.types';

const IngredientsSummary: React.FC<IIngredientsSummaryProps> = (props) => {
  const INGREDIENTS_AMOUNT = 8;
  const { title } = props;
  const { product } = useSelector(selectCurrentProduct);
  const { ingredients = [], allergens = [] } = product || ({} as Product);

  if (isEmpty(product)) {
    return null;
  }

  const list =
    (!isEmpty(ingredients) &&
      (ingredients as Ingredient[])
        .slice()
        .sort(({ display_sequence: a }, { display_sequence: b }) => a - b)
        .map((item) => item.ingredient)) ||
    [];
  const isComponentHidden = isEmpty(list) && isEmpty(allergens);

  let ingredientsSection;
  if (list && list.length && list.length <= INGREDIENTS_AMOUNT) {
    ingredientsSection = <IngredientsList list={list} />;
  } else if (list && list.length && list.length > INGREDIENTS_AMOUNT) {
    ingredientsSection = list.join(', ');
  } else {
    ingredientsSection = null;
  }

  const allergensSection =
    allergens && allergens.length ? (
      <ul className={styles.ingredientsSummary__allergensList}>
        {allergens.map(({ ingredient }) => (
          <li
            key={ingredient}
            className={styles.ingredientsSummary__allergensListItem}
          >
            {ingredient}
          </li>
        ))}
      </ul>
    ) : null;

  if (!allergensSection && !ingredientsSection) {
    return null;
  } else {
    return (
      <div className={styles.wrapper}>
        {!isComponentHidden && (
          <Section title={title}>
            <div className={styles.ingredientsSummary}>
              {ingredientsSection}
              {allergensSection}
            </div>
          </Section>
        )}
      </div>
    );
  }
};

export default IngredientsSummary;
